<template>
  <!-- (파일 변경) -->
  <div class="ly-inner">
    <idc-page-title :breadcrumbList="breadcrumbList">{{ pageTitle }}</idc-page-title>
    <!-- 통합화면으로 변경 -->
    <!-- <div class="table-block">
      <service-sub-total-contract-info :custId="custId" @serviceContractListClickRow="rowClick"></service-sub-total-contract-info>
    </div> -->
    <div class="table-block">
      <service-info :custId="custId" @serviceContractListClickRow="rowClick"></service-info>
    </div>
    <div class="table-block">
      <service-contract-info :custId="custId" @serviceContractListClickRow="rowClick"></service-contract-info>
    </div>
    <div class="table-block">
      <sub-service-contract-info :custId="custId"></sub-service-contract-info>
    </div>
    <!-- 22.03.17 개통현황, 서비스현황 영역 임시 주석처리 -->
    <!--
    <div class="table-block">
      <service-open-status :custId="'0003701371C'" @openWorkDetail="openWorkDetail" />
    </div>
    <div class="table-block">
      <service-requset @openWorkDetail="openWorkDetail" />
    </div>
    -->
    <!-- 22.03.15 작업상세화면 모달 추가 -->
    <idc-modal
      :visible.sync="modalWorkInfoDetail"
      :title="$t('messages.titWorkInfoDetail')"
      width="1140px"
    >
      <template #content>
        <work-info-detail></work-info-detail>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="modalWorkInfoDetail = false">작업승인</el-button>
        </div>
      </template>
    </idc-modal>
    <!-- 22.03.15 작업상세화면 모달 추가 -->
  </div>
</template>

<script>
import IdcPageTitle from "@/components/common/IdcPageTitle";
//import ServiceSubTotalContractInfo from "@/components/idcUsageStatus/contractStatus/ServiceSubTotalContractInfo";
import ServiceInfo from "@/components/idcUsageStatus/contractStatus/ServiceInfo";
import ServiceContractInfo from "@/components/idcUsageStatus/contractStatus/ServiceContractInfo";
import SubServiceContractInfo from "@/components/idcUsageStatus/contractStatus/SubServiceContractInfo";
import ServiceOpenStatus from "@/components/idcUsageStatus/contractStatus/ServiceOpenStatus";
import ServiceRequset from "@/components/idcUsageStatus/contractStatus/ServiceRequset";

// 22.03.15 작업상세화면 모달 추가
import WorkInfoDetail from "@/components/idcUsageStatus/requestStatus/WorkInfoDetail";
import IdcModal from "@/components/common/IdcModal";

export default {
  components: {
    ServiceInfo,
    ServiceContractInfo,
    SubServiceContractInfo,
    //ServiceSubTotalContractInfo,
    IdcPageTitle,
    ServiceOpenStatus,
    ServiceRequset,

    // 22.03.15 작업상세화면 모달 추가
    WorkInfoDetail,
    IdcModal,
  },
  data() {
    return {
      // 22.03.15 작업상세화면 모달 추가
      modalWorkInfoDetail: false,
      svcNo: "1234",
      title: this.$route.meta.title,
      navigator: this.$route.meta.navigator
    };
  },
  computed: {
    breadcrumbList() {
      return this.navigator;
    },
    pageTitle() {
      return this.title;
    },
    custId() {
      return this.$store.getters["userInfoStore/getCustId"];
    },
    i18n() {
      return this.$i18n.locale;
    }
  },
  watch: {
    i18n(newVal) {
      this.title      = (newVal === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn;
      this.navigator  = (newVal === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn;
    }
  },
  methods: {
    openWorkDetail() {
      // 22.03.15 작업상세화면 모달 이벤트 추가
      this.modalWorkInfoDetail = true;
    },
    rowClick(col,row) {
       //console.log("==============>"+row.svcNo);
       this.svcNo = row.svcNo;
    }
  },
  mounted() {
    this.title      = (this.i18n === 'ko') ? this.$route.meta.title : this.$route.meta.titleEn;
    this.navigator  = (this.i18n === 'ko') ? this.$route.meta.navigator : this.$route.meta.navigatorEn;
    /*
    this.$EventBus.$on("serviceContractListClickRow", (data) => {
      this.tableData = [];
    );
    */
  }
};
</script>

<style lang="scss" scoped>
.table {
  &-header {
    text-align: left;
    padding-bottom: 20px;
  }
  &-title {
    font-size: $--font-size-large;
    color: $--color-black;
    font-weight: $--font-weight-bold;
  }
  &-block {
    padding-top: 20px;
    &:not(:last-child) {
      padding-bottom: 40px;
    }
  }
}
</style>
